// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1V5__","rootSmall":"AddTileButton_rootSmall__2yUOg"};